import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default function NavContent({ setNavContent, navContent }) {
  return (
    <div
      className={`sm: absolute w-full bg-[#0d0f13dd] h-[100vh] font-varela text-[#D8E3E7] sm:hidden z-50 overflow-hidden ${
        navContent ? "" : "hidden"
      }`}
    >
      <FontAwesomeIcon
        icon={faClose}
        className="cursor-pointer text-[#818792] text-3xl p-5"
        onClick={() => {
          setNavContent(false);
        }}
      />
      <ul className="p-10 text-2xl font-semibold space-y-3">
        <li className="cursor-pointer hover:text-gray-100">Home</li>
        <li className="cursor-pointer hover:text-gray-100">About</li>
        <li className="cursor-pointer hover:text-gray-100">Sign In</li>
      </ul>
    </div>
  );
}
